export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex items-start justify-between mb-8 pb-6 border-b border-[#1f1f23]" data-testid={testid}>
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-white">{title}</h1>
        {subtitle && (
          <p className="font-mono text-xs text-zinc-500 mt-2 uppercase tracking-wider">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Stat({ label, value, accent, testid }) {
  return (
    <div className="border border-[#1f1f23] bg-[#0e0e10] p-5" data-testid={testid}>
      <p className="font-mono text-[10px] text-zinc-500 uppercase tracking-widest">{label}</p>
      <p className={`font-heading text-3xl mt-2 ${accent || "text-white"}`}>{value}</p>
    </div>
  );
}

export function Empty({ children, testid }) {
  return (
    <div
      className="border border-dashed border-[#27272a] bg-[#0a0a0c] p-10 text-center"
      data-testid={testid}
    >
      <p className="font-mono text-xs text-zinc-500 uppercase tracking-widest">{children}</p>
    </div>
  );
}

export function MonoNum({ children, className = "" }) {
  return (
    <span className={`font-mono text-sm text-white ${className}`}>{children}</span>
  );
}
